export type TipoUsuario = "ADM" | "OPERADOR" | "INSTRUMENTADOR";

/** Resposta de GET /usuario/me. */
export interface UsuarioLogado {
  id: string;
  nome: string | null;
  email: string;
  telefone: string | null;
  tipo: TipoUsuario;
  tipoRotulo: string;
  podeExcluirAgendamento: boolean;
  podeVerLog: boolean;
}

export interface FuncaoDisponivel {
  codigo: TipoUsuario;
  rotulo: string;
}

export interface FuncionalidadeCatalogo {
  codigo: string;
  rotulo: string;
  papeis: TipoUsuario[];
  /**
   * Nome do campo booleano do usuario que tambem precisa estar ligado, ou null
   * quando a funcao ja basta. E por isto que a lista sabe quais itens devem
   * acompanhar os interruptores em vez de acompanhar o select de funcao.
   */
  chave: "podeExcluirAgendamento" | "podeVerLog" | null;
}

export interface GrupoFuncionalidades {
  grupo: string;
  funcionalidades: FuncionalidadeCatalogo[];
}

/** Resposta de GET /usuario/funcionalidades. */
export interface CatalogoPermissoes {
  funcoes: FuncaoDisponivel[];
  grupos: GrupoFuncionalidades[];
}

/**
 * Decide se uma funcionalidade esta liberada. Mesma regra do
 * PermissaoCatalogo.permite no backend - a funcao precisa constar em `papeis`
 * E, quando ha `chave`, o interruptor correspondente precisa estar ligado.
 *
 * Isto aqui e so para DESENHAR a lista; quem autoriza de fato e o servidor.
 */
export const permiteFuncionalidade = (
  func: FuncionalidadeCatalogo,
  tipo: TipoUsuario,
  chaves: { podeExcluirAgendamento: boolean; podeVerLog: boolean }
): boolean => {
  if (!func.papeis.includes(tipo)) return false;
  if (!func.chave) return true;
  return chaves[func.chave];
};
